import { Search } from 'history';
import { parse as parseQueryString } from 'qs';
import { useMemo } from 'react';

export default <T = { [key: string]: string }>(search: Search) =>
  useMemo<T>(() => parseQueryString(search.slice(1)) as any, [search]);
